<template>
  <div class="container">
    <v-card>
      <v-system-bar height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Message
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <div class="col-md-12" style="margin-top: 50px;">
        <form>
          <!--  <div class="form-group">
            <label for="fcmTitle">Phone Token</label>
            <v-text-field
              v-model="NotificationToken"
              class="form-control"
              id="fcmTitle"
              aria-describedby="fcmTitleHelp"
            ></v-text-field>
          </div> -->

          <div class="form-group">
            <label for="fcmTitle">Titre</label>
            <v-text-field
              type="text"
              v-model="fcmJson.notification.title"
              class="form-control"
              id="fcmTitle"
              aria-describedby="fcmTitleHelp"
            ></v-text-field>
            <small id="fcmTitleHelp" class="form-text text-muted">{{
              fcmJson.notification.title
            }}</small>
          </div>

          <div class="form-group">
            <label for="fcmBody">Message</label>
            <v-text-field
              v-model="fcmJson.notification.body"
              class="form-control"
              id="fcmBody"
            ></v-text-field>
            <small id="fcmBodyHelp" class="form-text text-muted">{{
              fcmJson.notification.body
            }}</small>
          </div>

          <v-btn @click="Send" class="btn btn-primary">
            Envoyer
          </v-btn>
          <span v-if="alertMsg" v-html="alertMsg"></span>
        </form>
      </div>
    </v-card>
  </div>
</template>

<script>
const jsonApiHeader = {
  "Content-Type": "application/json; charset=UTF-8",
  Authorization:
    "key=AAAAXJUoq0o:APA91bHew9M1xuQXq82L23SoxIXAMzujxnhPCS_8kKA8VMyeAewdnnXwo0Gja-6oFb8Y7yR7lVJiP-GVVMt8_NY03j_pfYfQKAXLydfMBI7MhLLQrWiWW7kk6yVamglK-mqJCCCqPOvn",
};
import { mapState, mapActions } from "vuex";
import axios from "axios";
export default {
  created() {
    this.GetAllUsers();
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      fcmJson: (state) => state.Notifications.fcmJson,
      alertMsg: (state) => state.Notifications.alertMsg,
      NotificationToken: (state) => state.Auth.NotificationToken,
    }),
  },

  methods: {
    ...mapActions({
      /* Send: "Notifications/sendNotification", */
      GetAllUsers: "Notifications/GetAllUsers",
    }),
  },
};
</script>

<style scoped></style>
